const prefix = "[SCHEDULER_EXCEPTIONS]";

export default {
    CREATE_SCHEDULER_RULE_EXCEPTION_REQUEST: `${prefix} CREATE_SCHEDULER_RULE_EXCEPTION_REQUEST`,
    CREATE_SCHEDULER_RULE_EXCEPTION_SUCCESS: `${prefix} CREATE_SCHEDULER_RULE_EXCEPTION_SUCCESS`,
    CREATE_SCHEDULER_RULE_EXCEPTION_FAILED: `${prefix} CREATE_SCHEDULER_RULE_EXCEPTION_FAILED`,
    UPDATE_SCHEDULER_EXCEPTION_REQUEST: `${prefix} UPDATE_SCHEDULER_EXCEPTION_REQUEST`,
    UPDATE_SCHEDULER_EXCEPTION_SUCCESS: `${prefix} UPDATE_SCHEDULER_EXCEPTION_SUCCESS`,
    UPDATE_SCHEDULER_EXCEPTION_FAILED: `${prefix} UPDATE_SCHEDULER_EXCEPTION_FAILED`,
    FETCH_SCHEDULER_RULE_EXCEPTIONS_REQUEST: `${prefix} FETCH_SCHEDULER_RULE_EXCEPTIONS_REQUEST`,
    FETCH_SCHEDULER_RULE_EXCEPTIONS_SUCCESS: `${prefix} FETCH_SCHEDULER_RULE_EXCEPTIONS_SUCCESS`,
    FETCH_SCHEDULER_RULE_EXCEPTIONS_FAILED: `${prefix} FETCH_SCHEDULER_RULE_EXCEPTIONS_FAILED`,
    DELETE_SCHEDULER_EXCEPTION_REQUEST: `${prefix} DELETE_SCHEDULER_EXCEPTION_REQUEST`,
    DELETE_SCHEDULER_EXCEPTION_SUCCESS: `${prefix} DELETE_SCHEDULER_EXCEPTION_SUCCESS`,
    DELETE_SCHEDULER_EXCEPTION_FAILED: `${prefix} DELETE_SCHEDULER_EXCEPTION_FAILED`,
    FINISH_EXCEPTION_FORM_SUBMIT: `${prefix} FINISH_EXCEPTION_FORM_SUBMIT`,
    TOGGLE_EDIT: `${prefix} TOGGLE_EDIT`,
    CANCEL_EXCEPTION_UPDATE: `${prefix} CANCEL_EXCEPTION_UPDATE`,
};
